<template>
    <span :class="classes">
        <slot></slot>
    </span>
</template>
<script>
    import theme from './label.scss'

    export default {
        name: 'label',
        props: {
            orange: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    [theme.label]: true,
                    [theme.isOrange]: this.orange,
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Label.vue?41026d7a